import Cookies from 'js-cookie';

import {CLOSE, INSTALLED} from 'app/components/smartBanner/constants';
import {AndroidAppBannerConfig} from 'interfaces/shared/components/pages/smartappbanner/androidAppBannerConfig';

export function initSmartBanner(config: AndroidAppBannerConfig) {
    if (!/android/gi.test(navigator.userAgent) || Cookies.get(CLOSE) !== undefined || Cookies.get(INSTALLED) !== undefined) {
        return;
    }

    const closeButton = document.querySelector<HTMLElement>('.smartbanner__close');
    if (closeButton && config.daysHidden !== undefined) {
        closeButton.addEventListener('click', (e) => {
            if (config.daysHidden === undefined) {
                return;
            }

            e.preventDefault();
            removeClass();
            Cookies.set(CLOSE, 'true', {path: '/', expires: config.daysHidden});
        });
    }

    const installButton = document.querySelector<HTMLElement>('.smartbanner__button');
    if (installButton && config.daysReminder !== undefined) {
        installButton.addEventListener('click', () => {
            if (config.daysReminder === undefined) {
                return;
            }

            removeClass();
            Cookies.set(INSTALLED, 'true', {path: '/', expires: config.daysReminder});
        });
    }
}

function removeClass() {
    document.documentElement.classList.remove('smart-banner-active');
}
